




















































import { defineComponent } from '@nuxtjs/composition-api'
import { EXCLUDED_KITS } from '@/common/utils/product/constants'

export default defineComponent({
  props: {
    description: {
      type: String as () => string,
      required: false,
      default: undefined,
    },
    productType: {
      type: String,
      required: true,
    },
    attributes: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const showCASNumber = props.attributes.casNumber && !EXCLUDED_KITS.includes(props.productType)
    const showObservedMolecularWeight =
      props.attributes.observedMolecularWeight && !EXCLUDED_KITS.includes(props.productType)

    const hasTableData =
      props.attributes.purity ||
      props.attributes.endotoxin ||
      props.attributes.activity ||
      props.attributes.molecularFormula ||
      props.attributes.solubility

    const molecularWeightTypeCheck =
      props.attributes.molecularWeight &&
      (props.productType === 'Chemical Modulators' || props.productType === 'Cellular Dyes')

    const displayCondition = hasTableData || props.description || props.attributes.molecularWeight

    return {
      showCASNumber,
      showObservedMolecularWeight,
      molecularWeightTypeCheck,
      displayCondition,
    }
  },
})
